import { MenuItem } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import type { TagItem } from "src/queries/tags/tags.types";
import {
  MAX_TAGS_PER_GROUP,
  OVERFLOW_MESSAGE_TEMPLATE,
} from "../../AssetsFilterTags.constants";
import TagMenuItem from "../TagMenuItem/TagMenuItem";

interface StandaloneTagsListProps {
  tags: TagItem[];
  selectedTagIds: Set<number>;
  onToggle: (tagId: number) => void;
  searchText: string;
}

export default function StandaloneTagsList({
  tags,
  selectedTagIds,
  onToggle,
  searchText,
}: StandaloneTagsListProps) {
  if (tags.length === 0) return null;

  const visibleTags = tags.slice(0, MAX_TAGS_PER_GROUP);
  const hasMore = tags.length > MAX_TAGS_PER_GROUP;

  return (
    <>
      {visibleTags.map((tag) => (
        <TagMenuItem
          key={tag.tag_id}
          tag={tag}
          isStandalone
          isSelected={selectedTagIds.has(tag.tag_id)}
          onToggle={onToggle}
          searchText={searchText}
        />
      ))}

      {hasMore && (
        <MenuItem disabled className="py-0.5">
          <ListItemText
            primary={OVERFLOW_MESSAGE_TEMPLATE(tags.length - MAX_TAGS_PER_GROUP)}
            slotProps={{
              primary: {
                className: "text-xs text-secondary italic",
              },
            }}
          />
        </MenuItem>
      )}
    </>
  );
}
